import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RestDataLoader } from '../../shared/util/rest-data-loader';
import { UserFile } from '../model/user-file';
import { ResponseWrapper, RestResponse } from 'src/app/shared/model/rest-response';
import { environment } from 'src/environments/environment';
import { SystemPropertiesMap } from 'src/app/shared/model/system-properties-map';
import { RestSimpleRequest } from 'src/app/shared/model/rest-simple-request';
import { HttpClient, HttpEvent } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';
import { UserProfileService } from 'src/app/common/service/user-profile.service';
import { RequestCriteria } from 'src/app/shared/model/request-criteria';

@Injectable()
export class UserFileService extends RestDataLoader<UserFile> {

  private activeUserCriteria: RequestCriteria;

  constructor(http: HttpClient, translate: TranslateService, private userProfilService: UserProfileService) {
    super(http, translate);
  }

  protected getRestFetchEndpoint(): string {
    return this.activeUserCriteria && this.userProfilService.isService()
      ? 'api/admin/service/files/user-criteria'
      : 'api/files/list';
  }

  protected getEntityType(): any { return UserFile; }

  protected transformFetchPayload(payload: any): any {
    return this.activeUserCriteria && this.userProfilService.isService()
      ? this.changeUserCriteria(payload)
      : payload;
  }

  deleteFile(fileId: number): Observable<RestResponse<UserFile>> {
    return this.http.delete<RestResponse<UserFile>>(`${environment.serverUrl}api/files/delete/${fileId}`);
  }

  getDiskUsageStats(): Observable<SystemPropertiesMap> {
    return this.doGet('api/files/diskUsage');
  }

  reloadProcessing(fileId: number): Observable<RestResponse<UserFile>> {
    return this.doPost<RestResponse<UserFile>>(`api/files/reload-processing/${fileId}`);
  }

  setUserCriteria(userCriteria: RequestCriteria): void {
    this.activeUserCriteria = userCriteria;
  }

  public upload(formData: FormData, endpoint: string, extensions: string): Observable<HttpEvent<ResponseWrapper<Record<string, any>>>> {
    return this.doPostWithOptions<ResponseWrapper<Record<string, any>>>(endpoint, formData, {
      reportProgress: true,
      observe: 'events',
      headers: {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        'Available-extensions': extensions
      }
    });
  }

  checkUserFileNameExists(fileName: string): Observable<boolean> {
    return this.doGet<boolean>('api/files/exists/check', { fileName });
  }

  private changeUserCriteria(payload: RestSimpleRequest): RestSimpleRequest {

    return this.addToCriteria(payload, this.activeUserCriteria.fieldName, this.activeUserCriteria.value, this.activeUserCriteria.operator);
  }
}
